import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

let cache = null;
function loadUoms() {
  if (!cache) cache = api.get("/masters/uom").then(({ data }) => (data || []).filter((u) => u.is_active !== false)).catch(() => []);
  return cache;
}

/**
 * Dropdown of units from Masters → Units of Measure.
 * Default: value is the unit code (e.g. "NOS", "M3") — used by WBS forms.
 * Pass byId to key on the unit's id instead (a real uuid) — used by Service
 * Requisition / Work Order / Purchase Order lines, whose uom_id column is a
 * foreign key, not a code.
 */
export function UomSelect({ value, onChange, className, testId, byId = false }) {
  const [uoms, setUoms] = useState([]);
  useEffect(() => { loadUoms().then(setUoms); }, []);
  const key = (u) => (byId ? u.id : u.code);
  // "Nos" and "NOS" are the same unit: show the master's spelling instead of a second, duplicate entry (the stored value is only changed if the user picks another one)
  const match = byId ? null : uoms.find((u) => u.code && value && String(u.code).toLowerCase() === String(value).toLowerCase());
  const shown = match ? match.code : value;
  const known = uoms.some((u) => key(u) === shown);
  return (
    <Select value={shown || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
      <SelectTrigger className={className} data-testid={testId}><SelectValue placeholder="Unit" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">—</SelectItem>
        {shown && !known && <SelectItem value={shown}>{shown}</SelectItem>}
        {uoms.map((u) => <SelectItem key={u.id} value={key(u)}>{u.code}{u.name && u.name !== u.code ? ` — ${u.name}` : ""}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
